export enum DefectReviewStatus {
  NOT_REVIEWED = 1,
  COMPLETE = 2,
  NOT_A_DEFECT = 3,
}

export type DefectReviewString = "NOT REVIEWED" | "COMPLETED" | "NOT A DEFECT";

export type DefectReviewOption = {
  label: string;
  id: DefectReviewStatus;
};

export const defectReviewName: any = {
  1: "NOT REVIEWED",
  2: "COMPLETED",
  3: "NOT A DEFECT",
};
